export function getFirstAndLastItemsFromArray<T>(
  unknown: T[],
): [T | undefined, T | undefined] {
  if (!Array.isArray(unknown)) {
    return [undefined, undefined];
  }

  const first = unknown[0];
  const last = unknown[unknown.length - 1];

  return [first, last];
}
